/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrendingPlaylistNotificationActionData } from './TrendingPlaylistNotificationActionData';
import {
    TrendingPlaylistNotificationActionDataFromJSON,
    TrendingPlaylistNotificationActionDataFromJSONTyped,
    TrendingPlaylistNotificationActionDataToJSON,
} from './TrendingPlaylistNotificationActionData';

/**
 * 
 * @export
 * @interface TrendingPlaylistNotificationAction
 */
export interface TrendingPlaylistNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof TrendingPlaylistNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof TrendingPlaylistNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof TrendingPlaylistNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {TrendingPlaylistNotificationActionData}
     * @memberof TrendingPlaylistNotificationAction
     */
    data: TrendingPlaylistNotificationActionData;
}

/**
 * Check if a given object implements the TrendingPlaylistNotificationAction interface.
 */
export function instanceOfTrendingPlaylistNotificationAction(value: object): value is TrendingPlaylistNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TrendingPlaylistNotificationActionFromJSON(json: any): TrendingPlaylistNotificationAction {
    return TrendingPlaylistNotificationActionFromJSONTyped(json, false);
}

export function TrendingPlaylistNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendingPlaylistNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': TrendingPlaylistNotificationActionDataFromJSON(json['data']),
    };
}

export function TrendingPlaylistNotificationActionToJSON(value?: TrendingPlaylistNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': TrendingPlaylistNotificationActionDataToJSON(value.data),
    };
}

